    <div class="setting">
      <div>
        <div class="h7">Payments</div>
        <p class="p5">Track payment activity, revenue, and payouts for your locations.</p>
      </div>
    </div>

    <app-tab-view
      [tabs]="paymentsTabs"
      [defaultActiveTab]="activeTab"
      (tabChange)="onTabChange($event)">

      <div class="tab-content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </app-tab-view>
